import { PAYMENT_METHOD_ID } from "@/lib/constants";
import styles from "@/styles/PaymentIconImage.module.scss";
import classnames from "classnames";
import Image from "next/legacy/image";
import { useMemo } from "react";

const CreditCardTypes = {
  visa: "visa",
  V: "visa",
  jcb: "jcb",
  J: "jcb",
  mastercard: "master",
  M: "master",
  amex: "amex",
  A: "amex",
  dinersclub: "diners",
  D: "diners",
  all: "credit_card",
};

const DocomoTypes = {
  light: "docomo",
  dark: "docomo_light",
};

const SoftbankTypes = {
  light: "softbank",
  dark: "softbank_light",
};

const AuTypes = {
  light: "au",
  dark: "au_light",
};

const PayPayTypes = {
  light: "paypay_dark",
  dark: "paypay_light",
};

export default function PaymentIconImage({
  paymentMethodId,
  cardType,
  onDark = false,
  large = false,
  className,
}) {
  const type = useMemo(() => {
    const darkOrLight = onDark ? "dark" : "light";
    switch (paymentMethodId) {
      case PAYMENT_METHOD_ID.CREDIT_CARD_3DS:
        return CreditCardTypes[cardType];
      case PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS:
        return CreditCardTypes[cardType];
      case PAYMENT_METHOD_ID.DOCOMO:
        return DocomoTypes[darkOrLight];
      case PAYMENT_METHOD_ID.SOFTBANK:
        return SoftbankTypes[darkOrLight];
      case PAYMENT_METHOD_ID.AU:
        return AuTypes[darkOrLight];
      case PAYMENT_METHOD_ID.PAYPAY:
        return PayPayTypes[darkOrLight];
    }
  }, [paymentMethodId, cardType, onDark]);

  if (!type) return null;

  const iconClass = useMemo(() => {
    switch (paymentMethodId) {
      case PAYMENT_METHOD_ID.CREDIT_CARD_3DS:
        return type;
      case PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS:
        return type;
      case PAYMENT_METHOD_ID.DOCOMO:
        return "docomo";
      case PAYMENT_METHOD_ID.SOFTBANK:
        return "softbank";
      case PAYMENT_METHOD_ID.AU:
        return "au";
      case PAYMENT_METHOD_ID.PAYPAY:
        return "paypay";
    }
  }, [paymentMethodId, type]);

  return (
    <div
      className={classnames(styles.imageWrapper, styles[iconClass], {
        [styles.large]: large,
        [className]: !!className,
      })}
    >
      <Image
        src={`/images/payment_icon/payment_icon_${type}.png`}
        alt={type}
        layout="fill"
        objectFit="contain"
      />
    </div>
  );
}
